import type { SVGProps } from "react";

export default function SolarHome2Linear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M2 12.204c0-2.288 0-3.433.519-4.381c.52-.949 1.468-1.538 3.365-2.715l2-1.241C9.889 2.622 10.892 2 12 2s2.111.622 4.116 1.867l2 1.241c1.897 1.177 2.846 1.766 3.365 2.715C22 8.771 22 9.915 22 12.204v1.521c0 3.901 0 5.851-1.172 7.063C19.657 22 17.771 22 14 22h-4c-3.771 0-5.657 0-6.828-1.212C2 19.576 2 17.626 2 13.725z" />
        <path strokeLinecap="round" d="M12 15v3" />
      </g>
    </svg>
  );
}
